export class GeneralsToken {
  static IGeneralRepository = Symbol("IGeneralRepository");
  static GeneralsUseCase = Symbol("GeneralsUseCase");
}
